import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Descriptions   } from 'antd';
import { api, URL } from '../../api';
import Swal from 'sweetalert2/dist/sweetalert2.js'
export default class ModelRegister extends Component {


    constructor(props) {
              super(props);
      this.state = {
        modal: false,
        Curriculumopen:[],
        Curriculumopen_Full_Name_TH:'',
        Curriculumopen_Full_Name_EN:'',
        Curriculumopen_CH:'',

        Curriculumopen_ID:'',
        Studentcb_ID:'',
        Citizen:'',
        Numlist:[],
        
      }

this.handleSubmit = this.handleSubmit.bind(this);
this.getregisterCurriculum = this.getregisterCurriculum.bind(this);

}


            toggle = () => {
                this.setState({
                modal: !this.state.modal
                });
                this.setState({ Citizen:this.props.Citizen})
                this.getregisterCurriculum();
            }

            getregisterCurriculum() {
                setTimeout(() => {
                   //ภายใน
                   api.get('index/getregisterCurriculum/'+this.props.Curriculumopen_ID)
                   .then(res => {
                   //  console.log(res.data);
                     const Numlist = res.data.filter( ({ Studentcb_Citizen_ID }) => Studentcb_Citizen_ID === this.props.Citizen );
                   //  this.setState({ bankname: res.data, loading: false })
                     this.setState({ Numlist : Numlist})
                   
                   }) 
                 }, 0);
            }


            handleSubmit() {
                // alert('A name was submitted: ' + this.state.value);
                
               setTimeout(() => {
            
                  const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                  datafrm.append("Curriculumopen_ID", this.state.Curriculumopen_ID);
                  datafrm.append("Studentcb_ID", this.state.Studentcb_ID);
                  datafrm.append("Studentcb_Citizen_ID", this.state.Citizen);
                  
                  api.post("index/AddregisterCurriculum/",datafrm,{
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                   })
            
               .then(res => {
                //    console.log(res);
                    if (res.status === 200) {
                    //  alert("บันทึกสำเร็จ")
                              Swal.fire({
                                  title: 'ลงทะเบียนสำเร็จ',
                                  icon: 'success',
                                // showCancelButton: true,
                                  confirmButtonText: 'ตกลง',
                                // cancelButtonText: 'No, keep it'
                                }).then((result) => {
                                
                                })
                             }
                    })

                    this.getregisterCurriculum();
                    this.toggle()
                  //  this.props.getclassroom()
            }, 1000);
            
            //window.location.href = '/Curriculum'
            //this.props.updateat();
            //this.getExpert()
             
              }




            componentDidMount() {

                //const { id_send } = this.props.id_send
                //console.log(this.props.Curriculumopen_ID);
                this.setState({ Curriculumopen_ID:this.props.Curriculumopen_ID}) 
                this.setState({ Studentcb_ID:this.props.Studentcb_ID}) 
                this.setState({ Curriculumopen_Full_Name_TH:this.props.Curriculumopen_Full_Name_TH})
                this.setState({ Citizen:this.props.Citizen})
                //  this.setState({ Univ_ID:this.props.Univ_ID})
                // this.setState({ Univ_NAME:localStorage.getItem('Univ_NAME')})
                //this.setState({ Curriculumopen_User_UPDATE:localStorage.getItem('type2')})
              
                api.get('index/getCurriculumopenregis/'+this.props.Curriculumopen_ID,
                //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
                  //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                          {headers: {
                          // Authorization: 'Bearer ' + localStorage.getItem('myData')
                          }
                          })
                          //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                          .then(res => {
                          // console.log(res.data[0].id)
                          //  console.log(res.data)
                          //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                          //  console.log(Course)
                          this.setState({ Curriculumopen_Full_Name_TH : res.data[0].Curriculumopen_Full_Name_TH });
                          this.setState({ Curriculumopen_Full_Name_EN : res.data[0].Curriculumopen_Full_Name_EN });
                          this.setState({ Curriculumopen_CH : res.data[0].Curriculumopen_CH });
                             const Curriculumopen = res.data;
                              this.setState({ Curriculumopen });
                   }) 
             //  this.getteacherforcurriculum();
             this.getregisterCurriculum();
                }


    render() {
       // console.log(this.state.Numlist.length)
        return (
            <>
               {this.state.Numlist.length > 0 ?<>
                <h6 className="text-left"> ลงทะเบียนแล้ว</h6>
               </>:<>
               <MDBBtn onClick={this.toggle} color="info" >ลงทะเบียน</MDBBtn>
               </>}
                    

                    <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
                    <MDBModalHeader toggle={this.toggle}>ยืนยันการลงทะเบียน </MDBModalHeader>
                        <MDBModalBody>
                            {/* {this.props.Citizen} */}
                                <Descriptions title={"ลงทะเบียนวิชา "+this.state.Curriculumopen_Full_Name_TH} layout="vertical" bordered>
                                    <Descriptions.Item label="ชื่อภาษาไทย">{this.state.Curriculumopen_Full_Name_TH}</Descriptions.Item>
                                    <Descriptions.Item label="ชื่อภาษาอังกฤษ">{this.state.Curriculumopen_Full_Name_EN}</Descriptions.Item>
                                    <Descriptions.Item label="จำนวนชั่วโมง">{this.state.Curriculumopen_CH}</Descriptions.Item>
                                    
                                </Descriptions>
                             <br/>
                             {this.state.Numlist.length != 0 ?<><h3 className="text-center"> ลงทะเบียนแล้ว</h3> </>:<><p className="text-center">  <MDBBtn onClick={this.handleSubmit}>ยืนยันการลงทะเบียน</MDBBtn></p></>}
                             
                        </MDBModalBody>
                        <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                        {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
                        </MDBModalFooter>
                    </MDBModal>
               
            </>
        )
    }
}
